export const DefaultFileUpload = [
  {
    text: "We use the create method to turn a",
    code: "<input type='file'>",
  },
  {
    text: " into a FilePond drop area.",
    code: "[https://pqina.nl/filepond/]",
  },
];

export const ImagePreviewData = [
  {
    text: "We use the create method to turn a",
    code: "<input type='file'>",
  },
  {
    text: " into a FilePond drop area.",
    code: "[https://pqina.nl/filepond/]",
  },
];

export const FileUploadData = [
  {
    text: "Use the ",
    code: ".dropzone ",
  },
  {
    text: "class through create upload files.",
    code: "[https://www.dropzone.dev/].",
  },
];
